import { dataHooks } from '@wix/data-hooks'

export const wixStudioCreateExtendedDataHooks = dataHooks<{
  links: { id: string }
}>('wixStudioCreate')
